module.exports = __webpack_public_path__ + "img/威海华怡.b7aa625.png";